import userManagement from "./UserManagement";
import auth from "./Auth";
import dashboard from "./Dashboard";
import manageCms from "./ManageCms/index";
import adminProfile from "./AdminAccount/index";
import manageSubscription from "./ManageSubscription/index";
import userRecord from "./UserRecord/index";
import transactionHistory from "./TransactionsHistory/index";
import UserNutrition from "./UserNutrition/index";
import Support from "./Support/index";
import ManageNotifications from "./ManageNotifications/index";
import ManageBlogs from "./ManageBlogs/index";


/**
 * Combine and export access control modules related to various features such as user management, authentication, dashboard, CMS management, and admin account.
 * @constant {Object} AccessControl
 */
const AccessControl = {
  ...userManagement,
  ...auth,
  ...dashboard,
  ...manageCms,
  ...adminProfile,
  ...manageSubscription,
  ...userRecord,
  ...transactionHistory,
  ...UserNutrition,
  ...Support,
  ...ManageNotifications,
  ...ManageBlogs,
};

export default AccessControl;
